import React from 'react'
import HomePage from '../components/homepage/homepage.component'

const Home = () => {
  return (
    <HomePage />
  )
}

export default Home